import { getPath } from '@/router/common'

const baseUrl = {
  title: '区域参数设置',
  path: 'AreaData'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'AreaDataIndex',
    component: () => import(/* webpackChunkName: "AreaDataIndex" */ '@/views/areaData/index/index.vue'),
    meta: {
      title: '区域参数设置'
    }
  },
  {
    path: getPath('AreaMapSet', baseUrl),
    name: 'AreaMapSet',
    component: () => import(/* webpackChunkName: "AreaMapSet" */ '@/views/areaData/areaMapSet/index.vue'),
    meta: {
      title: '电子围栏区域设置'
    }
  },
  {
    path: getPath('areafrom', baseUrl),
    name: 'AreafromIndex',
    component: () => import(/* webpackChunkName: "areafrom" */ '@/views/areaData/areafrom/index.vue'),
    meta: {
      title: '电子围栏区域设置新增'
    }
  }
]
